import {
	GET_ACTIVE_PLATFORM_TIER_SUCCESS,
	GET_BILLING_FREQUENCY_OPTIONS_SUCCESS,
	GET_LAUNCH_INFO_SUCCESS,
	GET_USER_BILLING_SUMMARY_ERRORED,
	GET_USER_BILLING_SUMMARY_SUCCESS,
	GET_USER_PAYMENT_METHODS_SUCCESS,
	GET_USER_SUBSCRIPTION_PLANS_SUCCESS,
	GET_USER_SUCCESS,
	PATCH_REACTIVATE_ACCOUNT_SUCCESS,
	PATCH_USER_SUCCESS,
	POST_TRUSTED_CONTACT_SUCCESS,
	POST_USER_SUCCESS,
	SET_USER_IRA_ELIGIBILITY,
} from 'stash/actions/api';
import {
	CLEAR_BILLING_SUMMARY_REDUX_VALUE,
	CLEAR_PLANS_REDUX_VALUE,
} from 'stash/actions/user';

const capitalizeName = (name) => {
	if (typeof name !== 'string') return '';
	if (name.toLowerCase() !== name && name.toUpperCase() !== name) {
		return name;
	}
	return name.replace(/\w\S*/g, (txt) => {
		return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
	});
};

const formatNames = (user) => {
	return {
		first_name: capitalizeName(user.first_name),
		last_name: capitalizeName(user.last_name),
	};
};

const userReducer = (state = {}, action) => {
	switch (action.type) {
		case PATCH_USER_SUCCESS:
		case GET_USER_SUCCESS:
		case GET_LAUNCH_INFO_SUCCESS:
		case POST_USER_SUCCESS:
			return {
				...state,
				...action.response.user,
				...formatNames(action.response.user),
			};

		case GET_ACTIVE_PLATFORM_TIER_SUCCESS:
			const active_platform_tier = action.response.subscription;

			return {
				...state,
				platform_tier: active_platform_tier && active_platform_tier.plan,
			};

		case GET_BILLING_FREQUENCY_OPTIONS_SUCCESS:
			return {
				...state,
				billing_frequency_options: action.response.billingFrequencies,
				billing_frequency_disclosures: action.response.disclosures ?? [],
			};

		case CLEAR_BILLING_SUMMARY_REDUX_VALUE:
			return {
				...state,
				billing_summary: null,
			};

		case GET_USER_BILLING_SUMMARY_SUCCESS:
			return {
				...state,
				billing_summary: action.response?.billingSummary,
			};

		case GET_USER_BILLING_SUMMARY_ERRORED:
			return {
				...state,
				billing_summary_error: action.response.error,
			};

		case SET_USER_IRA_ELIGIBILITY:
			return {
				...state,
				ira_eligible: action.ira_eligible,
			};

		case PATCH_REACTIVATE_ACCOUNT_SUCCESS:
			return {
				...state,
				aasm_state: 'in_activation_process',
			};

		case GET_USER_PAYMENT_METHODS_SUCCESS:
			return {
				...state,
				payment_methods: action.response.paymentMethods,
			};

		case CLEAR_PLANS_REDUX_VALUE:
			return {
				...state,
				plans: null,
			};

		case GET_USER_SUBSCRIPTION_PLANS_SUCCESS:
			return {
				...state,
				plans: action.response,
			};

		case POST_TRUSTED_CONTACT_SUCCESS:
			return {
				...state,
				trusted_contact: action.response.trusted_contact,
			};

		default:
			return state;
	}
};

export default userReducer;
